/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Trial_Works_TitleInputs */

const en_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Trial Works`)
};

const ar_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيف تعمل النسخة التجريبية`)
};

const de_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie der Prozess funktioniert`)
};

const es_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona el periodo de prueba`)
};

const fr_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment fonctionne la période d'essai`)
};

const it_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funziona la prova`)
};

const ja_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルの仕組み`)
};

const ko_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`체험판 이용법 보기`)
};

const pt_br_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona o teste grátis`)
};

const ru_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О пробной версии`)
};

const th_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การทดลองใช้เป็นอย่างไร`)
};

const tr_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneme Sürümü Nedir`)
};

const zh_cn_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用说明`)
};

const zh_tw_how_trial_works_title = /** @type {(inputs: How_Trial_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試用說明`)
};

/**
* | output |
* | --- |
* | "How Trial Works" |
*
* @param {How_Trial_Works_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_trial_works_title = /** @type {((inputs?: How_Trial_Works_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Trial_Works_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_trial_works_title(inputs)
	if (locale === "ar") return ar_how_trial_works_title(inputs)
	if (locale === "de") return de_how_trial_works_title(inputs)
	if (locale === "es") return es_how_trial_works_title(inputs)
	if (locale === "fr") return fr_how_trial_works_title(inputs)
	if (locale === "it") return it_how_trial_works_title(inputs)
	if (locale === "ja") return ja_how_trial_works_title(inputs)
	if (locale === "ko") return ko_how_trial_works_title(inputs)
	if (locale === "pt_br") return pt_br_how_trial_works_title(inputs)
	if (locale === "ru") return ru_how_trial_works_title(inputs)
	if (locale === "th") return th_how_trial_works_title(inputs)
	if (locale === "tr") return tr_how_trial_works_title(inputs)
	if (locale === "zh_cn") return zh_cn_how_trial_works_title(inputs)
	return zh_tw_how_trial_works_title(inputs)
});